import SubmitApplications from './SubmitApplications';

export default SubmitApplications;
